export const emailValidation = (email) => {
    if (email) {
        let regex = /^[A-Za-z0-9_.-]+@[A-Za-z0-9-]+\.[A-Za-z0-9-]+$/;
        if (!regex.test(email)) {
            return false;
        }
    } else {
        return false;
    }

    return true;
};

export const genericEnterKeyDown = (e, callback) => {
    if (e.key === "Enter" && e.nativeEvent.isComposing === false) {
        callback();
    }
};
